import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { Transition } from '@tailwindui/react';
import useOutsideClick from '../hooks/useOutsideClick';

var EditorOverlay = function EditorOverlay(_ref) {
  var open = _ref.open,
      onClose = _ref.onClose,
      children = _ref.children;
  var ref = useRef(null);
  useOutsideClick(ref, onClose);
  useEffect(function () {
    var handleClose = function handleClose(e) {
      if (e.keyCode === 27) {
        onClose();
      }
    };

    window.addEventListener('keydown', handleClose);
    return function () {
      window.removeEventListener('keydown', handleClose);
    };
  }, []);
  return createPortal( /*#__PURE__*/React.createElement(Transition, {
    show: open,
    enter: "transition-all duration-200",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "transition-all duration-150",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-0 bg-gray-800 bg-opacity-50 z-10"
  }, /*#__PURE__*/React.createElement("div", {
    ref: ref
  }, children))), document.querySelector('#pdf-editor .pdf-content'));
};

export default EditorOverlay;